import {Component, Input, OnInit, ViewChild} from '@angular/core';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {NbDialogRef} from '@nebular/theme';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import {AuthorizationService} from '../../../services/authorization.service';

@Component({
  selector: 'ngx-logbooks-authorization-component',
  templateUrl: './logbooks-authorization-component.component.html',
  styleUrls: ['./logbooks-authorization-component.component.scss'],
})
export class LogbooksAuthorizationComponentComponent implements OnInit {

  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;
  @Input() stationId: string;
  @Input() isEdit: boolean;
  @Input() authorizationPerson: any = {
    name: '',
    role: '',
    enabled: true,
    signature: '',
    type: 'logbook',
  };

  loading = false;
  editSignature = false;
  signaturePadOptions: Object;

  constructor(
    protected ref: NbDialogRef<LogbooksAuthorizationComponentComponent>,
    protected authorizationService: AuthorizationService,
  ) { }

  ngOnInit() {
      this.signaturePadOptions = {
        maxWidth: 1,
        'minWidth': 0.8,
        'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
        'canvasWidth': 550,
      };
    }

    clearSignature() {
      this.signaturePad.clear();
    }

    close() {
      this.ref.close(false);
    }

    async create() {
      this.loading = true;
      this.authorizationPerson.signature = this.signaturePad.toDataURL();
      const [err] = await this.authorizationService.create(this.stationId, this.authorizationPerson);
      this.loading = false;
      if (err) {
        await this.alert('Oops, algo ocurrio', 'error', 'Intenta más tarde');
        this.close(); return;
      }
      await this.alert('Autorización Creada');
      this.ref.close(true);
    }

    async edit() {
      this.loading = true;
      const id = this.authorizationPerson.id;
      delete this.authorizationPerson.id;
      if (this.editSignature) this.authorizationPerson.signature = this.signaturePad.toDataURL();
      const [err] = await this.authorizationService.update(id, this.authorizationPerson);
      this.loading = false;
      if (err) {
        await this.alert('Oops, algo ocurrio', 'error', 'Intenta más tarde');
        this.close(); return;
      }
      await this.alert('Autorización Editada');
      this.ref.close(true);
    }

    async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
      await Swal.fire({
        icon: type,
        title: title,
        text: text,
      });
    }

}
